// extracted by mini-css-extract-plugin
module.exports = {"countryCard":"CountryCard_countryCard__1xcrV","image":"CountryCard_image__1y2Uh","details":"CountryCard_details__5O-T_","dark":"CountryCard_dark__1_QWZ"};